import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import GlobalContext from '../../context/store';
import { Get } from '../../api/server';

const APPLE_WALLET_BADGE = 'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/US-UK_Add_to_Apple_Wallet_RGB_101421.svg';
const GOOGLE_WALLET_BADGE = 'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/enUS_add_to_google_wallet_add-wallet-badge.svg';

export default function TicketConfirmation() {
  const { company } = useContext(GlobalContext);
  const { email: encodedEmail, id } = useParams();
  const email = encodedEmail ? decodeURIComponent(encodedEmail) : '';
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function loadTickets() {
      if (!company?._id || !email || !id) {
        setLoading(false);
        return;
      }
      try {
        const response = await Get(`/tickets/getUserTickets/${company._id}/${email}/${id}`);
        if (!cancelled && Array.isArray(response)) setTickets(response);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    loadTickets();
    return () => { cancelled = true; };
  }, [company?._id, email, id]);

  const applePass = id && email ? `https://liveonbeat.com/api/tickets/event/${id}/apple/${email}` : '';
  const androidPass = id && email ? `https://liveonbeat.com/api/tickets/event/${id}/android/${email}` : '';

  return (
    <section className="ticket-page ticket-confirmation">
      <div className="container">
        <div className="ticket-confirmation__intro">
          <p className="ticket-eyebrow">Ticket confirmation</p>
          <h1 className="ticket-page__title">You&apos;re in!</h1>
          <p className="ticket-confirmation__lead">Your QR tickets are on the way by email{email ? ` to ${email}` : ''}. Save them here too, so the door is easy.</p>
        </div>

        <section className="ticket-wallet" aria-labelledby="ticket-wallet-heading">
          <h2 id="ticket-wallet-heading">Add to your wallet</h2>
          <p>Keep the pass on your phone. Screenshots of the QR code work as well.</p>
          <div className="ticket-wallet__links">
            <a href={applePass} target="_blank" rel="noopener noreferrer" aria-label="Add to Apple Wallet"><img src={APPLE_WALLET_BADGE} alt="Add to Apple Wallet" /></a>
            <a href={androidPass} target="_blank" rel="noopener noreferrer" aria-label="Add to Google Wallet"><img src={GOOGLE_WALLET_BADGE} alt="Add to Google Wallet" /></a>
          </div>
        </section>

        <h2 className="ticket-confirmation__heading">Your tickets</h2>
        {loading && <div className="ticket-state"><p>Loading your tickets...</p></div>}
        {!loading && tickets.length === 0 && <div className="ticket-state"><p>Tickets are being prepared. Please check your confirmation email shortly.</p></div>}
        <div className="row justify-content-center">
          {tickets.map((ticket) => (
            <article className="col-md-4 mb-4" key={ticket._id}>
              <div className="ticket-card">
                <p className="ticket-eyebrow">Admit one</p>
                <h3>{ticket.event?.name}</h3>
                <p className="ticket-card__type">{ticket.ticketDescription || ticket.ticketInventory?.ticketName}</p>
                {[ticket.first_name, ticket.last_name].filter(Boolean).join(' ') && <p className="ticket-card__guest">{[ticket.first_name, ticket.last_name].filter(Boolean).join(' ')}</p>}
                <div className="ticket-card__rule" aria-hidden="true" />
                {ticket.scanid ? <div className="ticket-card__qr"><QRCodeSVG value={ticket.scanid} size={168} level="M" title={`Entry code for ${ticket.event?.name || 'ticket'}`} /></div> : <p>Ticket code is being prepared.</p>}
                <p className={`ticket-card__status${ticket.admitted ? ' is-used' : ''}`}>{ticket.admitted ? 'Used' : 'Ready for entry'}</p>
              </div>
            </article>
          ))}
        </div>
        <Link className="myButn ticket-confirmation__cta" to="/events">Explore more events</Link>
      </div>
    </section>
  );
}
